'use client';

import { type ChangeEvent, useEffect, useState } from 'react';

import { useGlobalStore } from '@/presenters/store/global';
import { zipCodeUtils } from '@/utils/zip-code-utils';

export default function useZipCode(useDefaultZipCode = true) {
  const defaultZipCode = useGlobalStore((store) => store.session?.zipCode);

  const [zipCode, setZipCode] = useState('');

  const zipCodeIsValid = zipCodeUtils.zipCodeIsValid(zipCode);
  const clearZipCode = () => setZipCode('');
  const setZipCodeToDefault = () => setZipCode(defaultZipCode || '');

  useEffect(() => {
    if (defaultZipCode && useDefaultZipCode) {
      setZipCode(defaultZipCode);
    }
  }, [defaultZipCode, useDefaultZipCode]);

  const onChangeZipCode = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    const zipCode = zipCodeUtils.formatZipCode(event.target.value);

    setZipCode(zipCode);
  };

  return {
    zipCode,
    onChangeZipCode,
    zipCodeIsValid,
    clearZipCode,
    setZipCodeToDefault,
  };
}
